import { useEffect, useState } from "react";

import { Spinner } from "../Spinner";

type SpinnerFallbackProps = {
  delay?: number;
};

export const SpinnerFallback = ({ delay = 420 }: SpinnerFallbackProps) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setShouldShow(true);
    }, delay);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [delay]);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="grid h-full w-full place-items-center">
      <Spinner className="size-8" />
    </div>
  );
};
